module.exports = __webpack_public_path__ + "img/hanuka_yes.d0c9336e.png";